<div class="dialog-content-wrapper">
    <mat-toolbar class="bg-primary m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="text-white">
            <span class="title dialog-title">Motivo de rechazo</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon class="text-white">close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-2 m-0" fusePerfectScrollbar>
        <lib-motivo-rechazo-form [idDiligencia]="idDiligencia" [idDiligenciaConfig]="idDiligenciaConfig" [createdBy]="createdBy"  [diligencia]="diligencia" [clasificacion]="clasificacion"></lib-motivo-rechazo-form>

        <div fxLayout="row" fxLayoutAlign="end end">
            <button (click)="save()" mat-raised-button type="button" color="accent" [disabled]="!formValid" *ngIf="canEnviar">
                Aceptar
            </button>
        </div>
    </div>
</div>